export const PaymentChoice = ({ cat, f, setF }) => {
  if (!cat.options.length) {
    return <p className="text-sm text-[#575757] mt-3 bg-[#F6FAF0] p-3" data-testid="agap-form-fee-note">Indicative fee: <b>{cat.fee}</b>. AGAP will confirm fees and benefits in your partner pack. No payment is taken now.</p>;
  }
  const radio = (checked, onChange, testid, text) => (
    <label className={`flex items-center gap-2 border px-3 py-2.5 text-sm cursor-pointer transition-colors ${checked ? "border-[#5E9420] bg-[#F6FAF0]" : "border-[#E7E7E7]"}`}>
      <input type="radio" checked={checked} onChange={onChange} data-testid={testid} className="accent-[#5E9420]" /> {text}
    </label>
  );
  return (
    <div className="mt-4 grid sm:grid-cols-2 gap-6">
      <div>
        <p className="text-xs text-[#575757]">Package</p>
        <div className="space-y-2 mt-1">{cat.options.map((o) => <div key={o.key}>{radio(f.price_key === o.key, () => setF({ ...f, price_key: o.key }), `agap-form-option-${o.key}`, o.label)}</div>)}</div>
      </div>
      <div>
        <p className="text-xs text-[#575757]">How would you like to pay?</p>
        <div className="space-y-2 mt-1">
          {radio(f.pay_now, () => setF({ ...f, pay_now: true }), "agap-form-pay-card", "Pay securely by card now")}
          {radio(!f.pay_now, () => setF({ ...f, pay_now: false }), "agap-form-pay-invoice", "Send me an invoice")}
        </div>
        <p className="text-[11px] text-[#8A8A8A] mt-2">Prices exclude VAT where applicable. AGAA members get 15–20% off event fees.</p>
      </div>
    </div>
  );
};
